import { Star, ExternalLink } from "lucide-react";

const testimonials = [
  {
    quote: "I began going to the chiropractor when I was around 9 or 10 years old and I saw Dr. Murray Greenspan, Dr. Kevin's father. He had horrible leg cramps that left me in tears. He is the only one who was able to help me at that time.",
    name: "Mindy F.",
    source: "Google Review",
  },
  {
    quote: "I had my initial consultation and it was amazing! Very knowledgeable and took the time to explain how everything works. It was great meeting the team.",
    name: "Gina H.",
    source: "Google Review",
  },
  {
    quote: "Dr. Greenspan provides excellent chiropractic services. He uses a variety of adjusting techniques — you pick. Applied Kinesiology and full body adjustments that really work.",
    name: "Kevin G. Patient",
    source: "Google Review",
  },
];

export default function Testimonials() {
  const doubled = [...testimonials, ...testimonials];

  return (
    <section id="testimonials" className="py-24 lg:py-32 bg-[#E4DCCF]/40 overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-12">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="font-body text-xs tracking-[0.2em] uppercase font-bold text-[#C87B5D] mb-4">
              Kind Words
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl font-medium text-[#1A221E] tracking-tight leading-none">
              What Patients Say
            </h2>
          </div>
          {/* Google rating badge */}
          {/* Google rating badge */}
          <a
            href="https://www.google.com/search?q=kevin+greenspan+chiropractor+reviews"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-white rounded-2xl border border-[#E4DCCF] px-5 py-3 hover:shadow-md transition-shadow cursor-pointer"
            data-testid="google-rating-badge"
          >
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} className={i < 5 ? "text-yellow-500 fill-yellow-500" : "text-gray-300"} />
              ))}
            </div>
            <div>
              <p className="font-body text-sm font-semibold text-[#1A221E]">Google Reviews</p>
              <p className="font-body text-xs text-[#5C6A61]">Read them on Google</p>
            </div>
            <ExternalLink size={14} className="text-[#C87B5D]" />
          </a>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative">
        <div className="marquee-track animate-marquee">
          {doubled.map((t, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-80 sm:w-96 mx-3 bg-white rounded-3xl border border-[#E4DCCF] p-8"
              data-testid={`testimonial-card-${i}`}
            >
              <p className="font-heading text-lg italic text-[#1A221E] leading-relaxed mb-6">
                "{t.quote}"
              </p>
              <div>
                <p className="font-body text-sm font-medium text-[#3A4F41]">{t.name}</p>
                <p className="font-body text-xs text-[#5C6A61]">{t.source}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
